import axios from "axios";
import toast from "react-hot-toast";
import { deleteStorageItem } from "./sessionStorage";

export const API = axios.create({
  baseURL: process.env.REACT_APP_PROD,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      deleteStorageItem("user-data");
      toast.error("Session expired. Please log in again.");
    }else if(error.response && error.response.status === 500){
      toast.error("Internal server error. Please try again later")
    }

    return Promise.reject(error);
  }
);